export default __webpack_public_path__ + "static/media/ce47a93e588216a65ef81faac8e0651cba134a3e450d76224ab01513ff183ba3.0cc8d06a.svg";